import type { InjectionKey } from 'vue';
import type { FileDownloadManager } from '@precon-tools-suite-by-shared/shared-file-downloads-data-access';

export const fileDownloadManagerInjectionKey = Symbol(
    'FileDownloadManager injection key form @precon-tools-suite-by-shared/shared-file-downloads-feature'
) as InjectionKey<FileDownloadManager>;
